import React, { useState, useEffect } from 'react'
import './styles/Table.css'
import MaterialTable from 'material-table'
// import GetAppIcon from '@material-ui/icons/GetApp'
// import FileUploadIcon from '@mui/icons-material/FileUpload'
import DeleteIcon from '@mui/icons-material/Delete'
import { Grid } from '@material-ui/core'
// import Swal from 'sweetalert2'
// import swal from 'sweetalert'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

// import { deletePrelegibilidad } from '../../../../../services/IFI/delete'
// import { getDraftFormsByUser } from '../../../../../services/Elegibilidad/get'
// import { deletePrelegibilidad } from '../../../../../services/IFI/delete'
import { useAuthentication } from '../../../../context/authenticationContext'
import { ModalRemoveRepresentationMipyme } from './Modal/ModalRemoveRepresentationMipyme'
import { getActiveMipymes } from '../../../../services/Representacion/get'
// import { deletePrelegibilidad } from '../../../../../services/IFI/delete'
const TableFormularios = () => {
  const { userIDB2C } = useAuthentication()
  const [loading, setLoading] = useState(true)
  const [open, setOpen] = useState(false)
  const [rowData, setRowData] = useState('')

  useEffect(() => {
    getInProcessForms()
  }, [])

  const getInProcessForms = async () => {
    try {
      const response = await getActiveMipymes(userIDB2C)
      console.log(response)
      if (response.Success) {
        if (response.Data.length > 0) {
          setTableForms(response.Data)
        } else {
          setTableForms([])
        }
      }
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
    setLoading(false)
  }

  const columns = [
    // {
    //   title: 'IdForm',
    //   field: 'IdForm',
    //   sorting: true,
    //   filtering: true,
    //   // cellStyle: { background: '#009688' },
    //   // headerStyle: { color: '#fff' },
    // },
    {
      title: 'Identificador',
      field: 'TaxRegistration',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'MIPYME',
      field: 'BusinessName',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Tipo MIPYME',
      field: 'MiPymeTypeDescription',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Condición MIPYME',
      field: 'MipymeCondition',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Estado MIPYME',
      field: 'MipymeStatus',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
  ]

  const [TableForms, setTableForms] = useState([])

  // const eliminateDraftForm = (idForm, formStage) => {
  //   if (
  //     idForm !== '' &&
  //     idForm !== undefined &&
  //     idForm !== null &&
  //     formStage === 'Formulario Pre-Elegibilidad'
  //   ) {
  //     Swal.fire({
  //       title: '¿Estas seguro?',
  //       text: 'Esta acción no es reversible!',
  //       icon: 'warning',
  //       showCancelButton: true,
  //       confirmButtonColor: '#3085d6',
  //       cancelButtonColor: '#d33',
  //       confirmButtonText: 'Confirmar',
  //       cancelButtonText: 'Cancelar',
  //       allowOutsideClick: false,
  //     }).then(async (result) => {
  //       if (result.isConfirmed) {
  //         const response = await deletePrelegibilidad(idForm)

  //         if (response.Code === 200) {
  //           swal({
  //             title: `Eliminado`,
  //             text: `El formulario ha sido eliminado con exito`,
  //             icon: `success`,
  //             closeOnClickOutside: false,
  //             closeOnEsc: false,
  //             buttons: {
  //               catch: {
  //                 text: 'Okay',
  //                 value: 'catch',
  //               },
  //             },
  //           }).then((value) => {
  //             console.log('swal', value)
  //             switch (value) {
  //               case 'catch':
  //                 swal.close()
  //                 break
  //               default:
  //                 swal.close()
  //             }
  //           })
  //         } else {
  //           swal({
  //             title: `Error`,
  //             text: `${response.Message}`,
  //             icon: `warning`,
  //             closeOnClickOutside: false,
  //             closeOnEsc: false,
  //             buttons: {
  //               catch: {
  //                 text: 'Okay',
  //                 value: 'catch',
  //               },
  //             },
  //           }).then((value) => {
  //             console.log('swal', value)
  //             switch (value) {
  //               case 'catch':
  //                 swal.close()
  //                 break
  //               default:
  //                 swal.close()
  //             }
  //           })
  //         }
  //       }
  //       getInProcessForms()
  //     })
  //   } else {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Oops...',
  //       text: 'Algo salió mal',
  //       footer:
  //         '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
  //     })
  //   }

  //   if (
  //     idForm !== '' &&
  //     idForm !== undefined &&
  //     idForm !== null &&
  //     formStage === 'Formulario Elegibilidad'
  //   ) {
  //     Swal.fire({
  //       title: 'PROCESO EN CONSTRUCCIÓN',
  //       text: 'Esta operación esta en construcción...',
  //       icon: 'info',
  //       showCancelButton: true,
  //       confirmButtonColor: '#3085d6',
  //       cancelButtonColor: '#d33',
  //       confirmButtonText: 'Confirmar',
  //       cancelButtonText: 'Cancelar',
  //       allowOutsideClick: false,
  //     })
  //     //   .then(async (result) => {
  //     //     if (result.isConfirmed) {
  //     //       deleteDraftForms(idForm, 'deleteForm')
  //     //     }
  //     //     getInProcessForms()
  //     //   })
  //     // } else {
  //     //   Swal.fire({
  //     //     icon: 'error',
  //     //     title: 'Oops...',
  //     //     text: 'Algo salió mal',
  //     //     footer:
  //     //       '<a href="mailto: comunicacionesCAMBio@bcie.org">Contactar al administrador</a>',
  //     //   })
  //   }
  // }
  // const editForm = (idForm, formStage) => {
  //   console.log(idForm, formStage)
  //   if (
  //     idForm !== '' &&
  //     idForm !== null &&
  //     idForm !== undefined &&
  //     formStage === 'Formulario Pre-Elegibilidad'
  //   ) {
  //     history.push(ROUTES.EDITAR.pathname, idForm)
  //   }
  //   if (
  //     idForm !== '' &&
  //     idForm !== null &&
  //     idForm !== undefined &&
  //     formStage === 'Formulario Elegibilidad'
  //   ) {
  //     // setIdEditForm(idForm)
  //     // getEditFormElegibility(idForm)
  //     // if (getEditFormElegibility) {
  //     // }
  //     history.push(ROUTES.EDITARELEGIBILIDAD.pathname, idForm)

  //     // Swal.fire({
  //     //   title: 'PROCESO EN CONSTRUCCIÓN',
  //     //   text: 'Esta operación esta en construcción...',
  //     //   icon: 'info',
  //     //   showCancelButton: true,
  //     //   confirmButtonColor: '#3085d6',
  //     //   cancelButtonColor: '#d33',
  //     //   confirmButtonText: 'Confirmar',
  //     //   cancelButtonText: 'Cancelar',
  //     //   allowOutsideClick: false,
  //     // })
  //   }
  //   // if (
  //   //   idForm !== '' &&
  //   //   idForm !== null &&
  //   //   idForm !== undefined &&
  //   //   formStage === 'Formulario Asistencia Tecnica'
  //   // ) {
  //   //   history.push(ROUTES.EDITARELEGIBILIDAD.pathname, idForm)
  //   // }
  // }

  return (
    <section>
      {!loading ? (
        <Grid
          container
          style={{
            width: '100%',
            height: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              height: 'auto',
              width: '96%',
              backgroundColor: '#fff',
              borderRadius: '4px',
            }}
          >
            <div className="App">
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12}>
                  <MaterialTable
                    columns={columns}
                    data={TableForms}
                    actions={[
                      {
                        icon: () => <DeleteIcon color="error" />,
                        tooltip: 'Eliminar',
                        onClick: (event, rowData) => {
                          setOpen(true)
                          setRowData(rowData)
                        },
                      },
                      // {
                      //   icon: () => <FileUploadIcon color="success" />,
                      //   tooltip: 'Activar Usuario',
                      //   onClick: (event, rowData) => {
                      //     Swal.fire({
                      //       title: '¿Está seguro de activar el usuario?',
                      //       icon: 'warning',
                      //       showCancelButton: true,
                      //       confirmButtonText: 'Si',
                      //       cancelButtonText: 'No',
                      //       dangerMode: true,
                      //     }).then((result) => {
                      //       if (result.isConfirmed) {
                      //         handleEnableUser(rowData.IdUser)
                      //       }
                      //     })
                      //   },
                      // },
                    ]}
                    onSelectionChange={(selectedRows) =>
                      console.log(selectedRows)
                    }
                    options={{
                      sorting: true,
                      search: true,
                      searchFieldAlignment: 'right',
                      searchAutoFocus: true,
                      searchFieldVariant: 'standard',
                      filtering: true,
                      paging: true,
                      pageSizeOptions: [2, 5, 10, 20],
                      pageSize: 5,
                      paginationType: 'stepped',
                      showFirstLastPageButtons: false,
                      paginationPosition: 'bottom',
                      exportButton: false,
                      exportAllData: true,
                      exportFileName: 'TableData',
                      // addRowPosition: 'first',
                      actionsColumnIndex: -1,
                      selection: false,
                      showSelectAllCheckbox: false,
                      showTextRowsSelected: false,
                      selectionProps: (rowData) => ({
                        disabled: rowData.age == null,
                        // color:"primary"
                      }),
                      // grouping: true,
                      columnsButton: false,
                      rowStyle: (data, index) =>
                        index % 2 === 0 ? { background: '#f5f5f5' } : null,
                      headerStyle: { background: '#014b96', color: '#fff' },
                    }}
                    localization={{
                      body: {
                        editRow: {
                          deleteText: '¿Está seguro de eliminar el registro?',
                        },
                        emptyDataSourceMessage: 'No hay registros a desplegar',
                      },
                      header: {
                        actions: 'Acciones',
                      },
                      toolbar: {
                        searchPlaceholder: 'Buscar',
                      },
                    }}
                    title=" "
                  />
                </Grid>
              </Grid>
            </div>
          </div>
          <ModalRemoveRepresentationMipyme
            open={open}
            setOpen={setOpen}
            rowData={rowData}
            getInProcessForms={getInProcessForms}
          />
        </Grid>
      ) : (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      )}
    </section>
  )
}
export default TableFormularios
